import { FC } from 'react'
import { RiskLevelCard } from '../RiskLevelCard'
import { ActionPlanCard } from '../ActionPlanCard'
import { SubHeaderContainer } from './SubHeader.styles'

const SubHeader: FC = () => {
    return (
        <SubHeaderContainer>
            <RiskLevelCard />
            <ActionPlanCard />
        </SubHeaderContainer>
    )
}

export default SubHeader
